import React, { FC, PropsWithChildren } from 'react';

import './style.css';

const Backdrop: FC<PropsWithChildren> = props => {
  return <div className="backdrop">{props.children}</div>;
};

export default Backdrop;
